import { TableRow, Theme, withStyles } from "@material-ui/core";

export default withStyles((theme: Theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.grey[200],
    },
  },
}))(TableRow);
